'use client'

import React from 'react'
import styled from 'styled-components'

import {Image} from '@/src/shared/ui/image'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Container = styled.div`
  height: auto;
`

const Loading = (props: React.PropsWithChildren) => {
  return (
    <Wrapper {...props}>
      <Container>
        <Image
          src="/run-loader.gif"
          alt="Загрузка"
          unoptimized
          quality={100}
          width={100}
          height={100}
        />
      </Container>
    </Wrapper>
  )
}

export default Loading
